import { useState } from 'react'
import ReactPlayer from 'react-player'
import {
  MediaController,
  MediaControlBar,
  MediaTimeRange,
  MediaTimeDisplay,
  MediaVolumeRange,
  MediaPlaybackRateButton,
  MediaPlayButton,
  MediaSeekBackwardButton,
  MediaSeekForwardButton,
  MediaMuteButton,
  MediaFullscreenButton
} from 'media-chrome/react'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useVideoAnalytics } from '../../hooks/useVideoAnalytics'
import IconButton from '@mui/material/IconButton'

export default function ReactVideoPlayer ({ videoUrl = '', poster, autoPlay = false, /* isPlaying, */ isExpanded = false, onClose, onPlay, videoId }) {
  const splash = videoUrl.replace('mp4', 'jpg')
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [playing, setPlaying] = useState(autoPlay)
  const [videoReady, setVideoReady] = useState(false)
  const [playerKey, setPlayerKey] = useState(0)

  const handlePreviewClick = () => {
    if (!playing) {
      setPlaying(true)
    } else {
      setPlaying(false)
    }
  }

  // Use video analytics hook
  const {
    // eslint-disable-next-line no-unused-vars
    handlePlay: trackPlay,
    // eslint-disable-next-line no-unused-vars
    handlePause: trackPause,
    handleProgress: trackProgress,
    handleComplete: trackComplete
  } = useVideoAnalytics(videoUrl, 'Race Video')

  return (
    <MediaController
      volume={0.5}
      playing={playing}
      style={{
        width: isExpanded ? '100vw' : '100%',
        height: isExpanded ? videoId === 2 ? 'calc(100vh - 56px)' : '100vh' : 'auto',
        // height: isExpanded ? '100vh' : 'auto',
        aspectRatio: isExpanded ? 'unset' : '16/9',
        position: isExpanded ? 'fixed' : 'relative',
        top: isExpanded ? videoId === 2 ? 56 : 0 : 'auto',
        left: isExpanded ? 0 : 'auto',
        zIndex: isExpanded ? 999 : 'auto',
        backgroundColor: isExpanded ? '#000' : 'transparent',
        transition: 'all 0.3s ease'
      }}
    >
      <ReactPlayer
        preload='true'
        playsInline
        loop
        // controls={true}
        slot='media'
        src={videoUrl}
      // controls={false}
        light={poster || splash}
        playing={playing}
        onClickPreview={handlePreviewClick}
        onClick={handlePreviewClick}
        style={{
          width: '100%',
          height: '100%'
        // '--controls': 'none'
        }}
        onPlay={() => {
          setPlaying(true)
          onPlay?.()
        }}
        onPause={() => {
          setPlaying(false)
        }}
        onEnded={() => {
          trackComplete()
          onClose?.()
        }}
        onProgress={trackProgress}
        onReady={() => setVideoReady(true)}
        key={playerKey}
        config={{
          youtube: {
            playerVars: {
              autoplay: 1, // Autoplay the video (note: browser restrictions may apply)
              controls: 0, // Hide native YouTube controls
              disablekb: 1, // Disable keyboard controls
              showinfo: 0, // Hide video title and uploader info (deprecated by YouTube)
              rel: 0, // Do not show related videos at the end
              modestbranding: 1
            }
          }
        }}
      />
      {videoReady && (
      <MediaControlBar>
        <MediaPlayButton />
        <IconButton
          onClick={() => {
            setPlaying(false)
            trackComplete()
            setTimeout(() => {
              setPlayerKey(k => k + 1)
              setVideoReady(false)
            }, 100)
            onClose?.()
          }}
          sx={{
            color: 'white',
            padding: '8px',
            ':hover': { opacity: 0.8 }
          }}
        >
          <svg width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
            <path d='M18 6L6 18M6 6l12 12' />
          </svg>
        </IconButton>
        <MediaSeekBackwardButton seekOffset={10} />
        <MediaSeekForwardButton seekOffset={10} />
        <MediaTimeRange />
        <MediaTimeDisplay showDuration />
        {!isMobile && <MediaMuteButton />}
        {!isMobile && <MediaVolumeRange />}
        {!isMobile && <MediaPlaybackRateButton />}
        <MediaFullscreenButton />
      </MediaControlBar>
      )}
      {isExpanded && (
        <IconButton
          onClick={() => {
            setPlaying(false)
            trackComplete()
            setPlayerKey(k => k + 1)
            setVideoReady(false)
            onClose?.()
          }}
          sx={{
            position: 'absolute',
            top: '80px',
            right: '20px',
            zIndex: 1000,
            background: 'rgba(0,0,0,0.7)',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background 0.2s',
            ':hover': {
              background: 'rgba(0,0,0,0.9)'
            }
          }}
        >
          <svg width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
            <path d='M18 6L6 18M6 6l12 12' />
          </svg>
        </IconButton>
      )}
    </MediaController>
  )
}
